module.exports = __webpack_public_path__ + "img/compresores.bf0380e7.png";